import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessagePipe } from './error-message/error-message.pipe';
import { IncludesStringPipe } from './includes/includes.pipe';

@NgModule({
	imports: [CommonModule],
	exports: [ErrorMessagePipe, IncludesStringPipe],
	declarations: [ErrorMessagePipe, IncludesStringPipe],
})
export class PipesModule {}
